(function () {
  "use strict";
  window.PEAK_ASSIST_API = window.PEAK_ASSIST_API || 'https://peaksaunasteam.com/assist';


  // --- GA4 funnel instrumentation (added 2026-07-29) -----------------------
  // Transport note: peaksaunas.com serves GA4 ONLY through Shopify's Web
  // Pixels sandbox, so window.gtag is undefined on ordinary storefront pages
  // (verified live 2026-07-29). We therefore load our own gtag with
  // send_page_view:false -- the exact pattern already proven in production on
  // /pages/landing-page-11, whose pms_* events land in GA4 today. Page views
  // stay owned by Shopify's pixel; this tag only emits our custom events.
  // Sends counts and enums only -- never message text, name, phone or email.
  var PA_GA4_ID = 'G-Q4S7FKHHR8';
  var PA_TRACK_VER = 'pa-1.0';
  var paTrackedOnce = {};
  var paGtagBooted = false;
  var paMsgSeq = 0;
  var paClosing = false;

  // Defines the gtag shim SYNCHRONOUSLY (so events queue into dataLayer and
  // flush once gtag.js lands) but defers the ~100KB script fetch to idle time
  // so site-wide instrumentation costs nothing against LCP.
  function paEnsureGtag() {
    if (typeof window.gtag === 'function') return true;  // LP pages already have it
    if (paGtagBooted) return true;
    paGtagBooted = true;
    try {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () { window.dataLayer.push(arguments); };
      window.gtag('js', new Date());
      window.gtag('config', PA_GA4_ID, { send_page_view: false, transport_type: 'beacon' });
      var load = function () {
        var s = document.createElement('script');
        s.async = true;
        s.src = 'https://www.googletagmanager.com/gtag/js?id=' + PA_GA4_ID;
        document.head.appendChild(s);
      };
      if (window.requestIdleCallback) window.requestIdleCallback(load, { timeout: 4000 });
      else setTimeout(load, 2000);
      return true;
    } catch (err) { return false; }
  }

  function paTrack(name, params) {
    try {
      if (!paEnsureGtag()) return;
      var p = params || {};
      p.widget_version = PA_TRACK_VER;
      p.pa_device = window.matchMedia('(max-width: 768px)').matches ? 'mobile' : 'desktop';
      p.pa_page = location.pathname;
      window.gtag('event', name, p);
    } catch (err) { /* analytics must never break the widget */ }
  }
  function paTrackOnce(name, params) {
    if (paTrackedOnce[name]) return;
    paTrackedOnce[name] = true;
    paTrack(name, params);
  }

  var askInput = document.getElementById('paf-ask-input');
  var askPill = document.querySelector('#peak-action-footer .paf-ask-pill');
  var sendBtn = document.getElementById('paf-send-btn');
  if (askPill) paTrackOnce('peak_assist_impression', {});

  // --- GHL chat-widget detection: poll for its open shadow root, then hide
  // its own launcher/prompt so this footer's pill is the only visible entry
  // point. SAFETY: this file never queries or clicks #lc_text-widget--send-btn
  // — that button posts to the LIVE GHL account, so sending stays a manual,
  // human action inside the widget itself.
  var widgetReady = false;
  var widgetHost = null;
  var widgetShadow = null;

  (function pollWidget(elapsed) {
    var el = document.querySelector('chat-widget');
    var sr = el && el.shadowRoot;
    if (sr) {
      if (!sr.getElementById('paf-widget-style')) {
        var style = document.createElement('style');
        style.id = 'paf-widget-style';
        style.textContent = '.lc_text-widget--bubble, .lc_text-widget--prompt { display: none !important; }';
        sr.appendChild(style);
      }
      widgetHost = el;
      widgetShadow = sr;
      widgetReady = true;
      return;
    }
    if (elapsed >= 12000) return;
    setTimeout(function () { pollWidget(elapsed + 250); }, 250);
  })(0);

  function updateSendState() {
    if (askInput.value.trim().length > 0) {
      sendBtn.classList.add('paf-active');
    } else {
      sendBtn.classList.remove('paf-active');
    }
  }

  // The old GHL launcher-click + textarea-prefill helper was removed this
  // round — the pill now opens the Peak Assist panel below instead of the
  // GHL window. The widget-detection poll above is unchanged and still
  // hides the GHL widget's own launcher/prompt via shadow-DOM style
  // injection.
  function sendAsk() {
    var val = askInput.value.trim();
    askInput.value = '';
    updateSendState();
    paOpenPanel(val || null);
  }

  askPill.addEventListener('click', function (e) {
    if (e.target === sendBtn || sendBtn.contains(e.target)) return;
    paTrack('peak_assist_bar_click', { resumed: (paHasThread || paContact) ? 1 : 0 });
    // A click on the bar must OPEN THE CHAT. Until 2026-08-04 this only called
    // askInput.focus() when there was no existing thread, so 67 of 109 people
    // who clicked (5 days to 08-03) saw nothing happen. Opening the panel is
    // what a chat launcher is expected to do.
    if (paIsOpen()) {
      paInput.focus();
      return;
    }
    // Carry over anything already typed in the footer pill, but do NOT send it
    // -- sending stays the visitor's decision.
    var carried = askInput.value.trim();
    askInput.value = '';
    updateSendState();
    paOpenPanel();
    if (carried) {
      paInput.value = carried;
      paUpdateSendState();
    }
  });
  askInput.addEventListener('input', updateSendState);
  sendBtn.addEventListener('click', sendAsk);
  askInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      sendAsk();
    }
  });

  // --- PA_P0_BUNDLE: 2-field modal + phone mask + hours copy + error/api telemetry (2026-08-05) ---
  var PCM_COPY_OPEN = 'Our team is available now — expect a call shortly.';
  var PA_TEAM = { on: false, who: '', photo: '', plural: false, note: 'Mon–Fri 8am–7pm CT' };  /* PA_TEAM_AWARE 2026-09-25 */
  var PCM_COPY_CLOSED = 'It\'s after hours — we\'ll call you when we reopen.';
  var hoursChecked = false;
  var hoursCopy = '';

  var scheduleBtn = document.getElementById('paf-schedule-btn');
  var modal = document.getElementById('peak-call-modal');
  var closeBtn = document.getElementById('pcm-close-btn');
  var formView = document.getElementById('pcm-form-view');
  var successView = document.getElementById('pcm-success-view');
  var form = document.getElementById('pcm-form');
  var nameInput = document.getElementById('pcm-name');
  var phoneInput = document.getElementById('pcm-phone');
  var emailInput = document.getElementById('pcm-email');
  var emailToggle = document.getElementById('pcm-email-toggle');
  var emailRow = document.getElementById('pcm-email-row');
  var submitBtn = document.getElementById('pcm-submit-btn');
  var formError = document.getElementById('pcm-form-error');
  var successMsg = document.getElementById('pcm-success-msg');
  var doneBtn = document.getElementById('pcm-done-btn');
  var hoursEl = document.getElementById('pcm-hours');
  var lastFocused = null;

  function setError(input, msg) {
    var el = document.getElementById(input.id + '-error');
    if (!el) return;
    if (msg) {
      el.textContent = msg;
      el.classList.add('pcm-show');
      input.classList.add('pcm-invalid');
    } else {
      el.textContent = '';
      el.classList.remove('pcm-show');
      input.classList.remove('pcm-invalid');
    }
  }

  [nameInput, phoneInput, emailInput].forEach(function (input) {
    input.addEventListener('input', function () { setError(input, ''); });
  });

  // International entry (leading '+') and anything past 10 digits is left
  // completely untouched. Caret must be at the end of the field or we skip
  // reformatting for that keystroke, to avoid cursor-jump bugs.
  function formatPhone() {
    var val = phoneInput.value;
    var digits = val.replace(/\D/g, '');
    if (val.charAt(0) === '+' || digits.length > 10) return;
    if (phoneInput.selectionStart !== val.length) return;
    var out = digits;
    if (digits.length > 6) {
      out = '(' + digits.substr(0, 3) + ') ' + digits.substr(3, 3) + '-' + digits.substr(6);
    } else if (digits.length > 3) {
      out = '(' + digits.substr(0, 3) + ') ' + digits.substr(3);
    } else if (digits.length > 0) {
      out = '(' + digits;
    }
    phoneInput.value = out;
  }
  phoneInput.addEventListener('input', formatPhone);

  // US-only lead gate. Mirrors us_phone.py on the server, which is the real
  // gate -- this exists so the visitor sees the reason before submitting.
  // Canada and the Caribbean share +1, so they are refused by area code here
  // too. US territories (787/939/671/670/684/340) are US. Keep in step with
  // us_phone.py NON_US_NPA -- test_us_phone_client.js checks that.
  var PA_TOLLFREE_NPA = /^(800|822|833|844|855|866|877|88[0-9])$/;
  var PA_SERVICE_NPA = /^(700|710|900|950|958|959)$/;
  var PA_NON_US_NPA = (
    // Canada
    '204 226 236 249 250 257 263 289 306 343 354 365 367 368 382 387 403 416 ' +
    '418 428 431 437 438 450 468 474 506 514 519 548 579 581 584 587 600 604 ' +
    '613 622 639 647 672 683 705 709 742 753 778 780 782 807 819 825 867 873 ' +
    '879 902 905 ' +
    // Caribbean / Atlantic NANP members that are not US territories
    '242 246 264 268 284 345 441 473 649 658 664 721 758 767 784 809 829 849 ' +
    '868 869 876'
  ).split(' ');

  function paValidateUsPhone(raw) {
    raw = (raw || '').trim();
    if (!raw) return { ok: false, error: 'Please enter a US phone number — 10 digits, area code first.' };
    var plus = raw.charAt(0) === '+';
    var digits = raw.replace(/\s*(?:x|ext\.?|extension|#)\s*\d{1,6}\s*$/i, '').replace(/\D/g, '');
    var badFormat = { ok: false, error: 'Please enter a US phone number — 10 digits, area code first.' };
    if (digits.indexOf('011') === 0) return badFormat;
    if (digits.length === 11 && digits.charAt(0) === '1') digits = digits.slice(1);
    else if (plus && digits.charAt(0) !== '1') return badFormat;
    if (digits.length !== 10) return badFormat;

    var npa = digits.slice(0, 3), nxx = digits.slice(3, 6);
    if (PA_TOLLFREE_NPA.test(npa)) {
      return { ok: false, error: "Please enter a direct line — toll-free numbers can't be used." };
    }
    if (PA_SERVICE_NPA.test(npa) || nxx === '976') {
      return { ok: false, error: "That number can't be reached — please enter a direct line." };
    }
    var invalid = { ok: false, error: "Please check the number — that isn't a valid US phone number." };
    if (!/^[2-9]/.test(npa) || npa.slice(1) === '11' || npa.slice(0, 2) === '37' || npa.slice(0, 2) === '96') return invalid;
    if (!/^[2-9]/.test(nxx) || nxx.slice(1) === '11' || nxx === '555') return invalid;
    if (/^(\d)\1{9}$/.test(digits)) return invalid;
    if (PA_NON_US_NPA.indexOf(npa) !== -1) {
      return { ok: false, error: 'We only serve the United States — please enter a US phone number.' };
    }
    return { ok: true };
  }

  function openModal() {
    lastFocused = document.activeElement;
    modal.classList.add('pcm-enter');
    modal.style.display = 'flex';
    void modal.offsetHeight;
    requestAnimationFrame(function () { modal.classList.remove('pcm-enter'); });
    setTimeout(function () { modal.classList.remove('pcm-enter'); }, 150);
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('pcm-open');
    if (paContact) {
      if (!nameInput.value) nameInput.value = paContact.name;
      if (!phoneInput.value) phoneInput.value = paContact.phone;
    }
    checkHours();
    setTimeout(function () { nameInput.focus(); }, 0);
  }

  function closeModal() {
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('pcm-open');
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  }

  function applyHoursCopy() {
    if (hoursEl) hoursEl.textContent = hoursCopy;
  }

  // Fires at most once per pageview (first modal open); later opens just
  // re-apply whatever was cached. ES5-safe stand-in for AbortController: a
  // plain setTimeout race that ignores a late response instead of cancelling
  // it. On ANY failure or timeout the copy stays '' -- never show a wrong
  // promise when the API is unreachable.
  function checkHours() {
    if (hoursChecked) {
      applyHoursCopy();
      return;
    }
    hoursChecked = true;
    hoursCopy = '';
    applyHoursCopy();
    var settled = false;
    setTimeout(function () { settled = true; }, 4000);
    fetch((window.PEAK_ASSIST_API || '') + '/healthz').then(function (res) {
      return res.json();
    }).then(function (json) {
      if (settled) return;
      settled = true;
      try { paApplyTeam(json); } catch (e) {}
      if (json && json.biz_hours_now === true) hoursCopy = PCM_COPY_OPEN;
      else if (json && json.biz_hours_now === false) hoursCopy = PCM_COPY_CLOSED;
      applyHoursCopy();
    }).catch(function () {
      settled = true;
    });
  }

  /* PA_TEAM_AWARE 2026-09-25 */
  // Who is on right now (backend roster: /root/peak-assist-api/roster.json). Drives the footer button,
  // the ask pill, the call modal, the chat header, and the PDP call card. Off hours = neutral copy, grey dot.
  function paSetText(id, t) { var el = document.getElementById(id); if (el) el.textContent = t; }
  function paSetImg(id, src) { var el = document.getElementById(id); if (!el) return; if (src) { el.src = src; el.hidden = false; } else { el.hidden = true; } }
  function paApplyTeam(json) {
    var team = ((json && json.team_on) || []).slice(0, 1); /* PKJ_ONE_FACE v21 (austin-cc 9/30): one face at a time, Becca then Ben, then the PEAK icon */
    var on = !!(json && json.biz_hours_now) && team.length > 0;
    var names = team.map(function (t) { return t.name; });
    var who = names.length === 0 ? '' : (names.length === 1 ? names[0] : names.slice(0, -1).join(', ') + ' & ' + names[names.length - 1]);
    var withPhoto = team.filter(function (t) { return t.photo; })[0];
    var photo = withPhoto ? withPhoto.photo + (withPhoto.photo.indexOf('?') < 0 ? '?width=120&height=120&crop=center' : '') : '';
    var note = (json && json.hours_note) || PA_TEAM.note;
    PA_TEAM = { on: on, who: who, photo: photo, plural: names.length > 1, note: note, names: names };
    var mobile = window.innerWidth < 768;
    paSetText('paf-schedule-label', 'Request a callback');
    paSetText('pkj-chat-label', on ? 'Chat with ' + names[0] : 'Ask us anything');
    paSetText('pcm-title', on ? 'Talk to ' + who : 'Talk to our team');
    paSetImg('paf-who-img', on ? photo : ''); paSetImg('paf-ask-img', on ? photo : '');
    var dot = document.getElementById('paf-dot'); if (dot) dot.classList.toggle('is-on', on);
    if (askInput) askInput.placeholder = on ? (mobile ? 'Chat with us' : 'Chat with ' + who) : 'Ask anything';
    paSetText('pcm-subtitle', on ? 'Leave your info and ' + who + ' will give you a quick call.' : 'Leave your info and we\'ll call you when we reopen (' + note + ').');
    paSetImg('pcm-avatar', on ? photo : '');
    PCM_COPY_OPEN = on ? who + (PA_TEAM.plural ? ' are' : ' is') + ' available now \u2014 expect a call shortly.' : 'Our team is available now \u2014 expect a call shortly.';
    if (json && typeof json.biz_hours_now === 'boolean') { hoursCopy = json.biz_hours_now ? PCM_COPY_OPEN : PCM_COPY_CLOSED; applyHoursCopy(); }
    paSetText('pa-title', on ? 'Chat with ' + who : 'Peak Assist');
    paSetText('pa-status-text', on ? 'Online now \u00b7 replies in a few minutes' : 'Answers now \u00b7 team back ' + note);
    var hd = document.getElementById('pa-header-avatar-img'); if (hd) hd.src = (on && photo) ? photo : PA_AVATAR_URL;
    var sd = document.getElementById('pa-status-dot'); if (sd) sd.classList.toggle('is-off', !on);
    var eye = document.querySelector('.pk-call-eyebrow'); if (eye) eye.textContent = on ? 'Talk to ' + who : 'Talk to our team';
    var head = document.querySelector('.pk-call-head'); if (head) head.textContent = head.textContent.replace(/Call or text .*? for a/, 'Call or text ' + (on ? who : 'us') + ' for a');
    var av = document.querySelector('.pk-call-avatar'); if (av) { if (on && photo) { av.src = photo; av.hidden = false; } else { av.hidden = true; } }
    var avail = document.querySelector('.pk-avail'); if (avail) avail.classList.toggle('is-off', !on);
    var at = document.querySelector('[data-pk-availtext]'); if (at) at.textContent = on ? 'Available now' : 'Back ' + note + ' \u00b7 Leave us a message';
  }
  /* PKJ_TEAM_EVENT v21 (austin-cc 9/30): share who is on with the chat button + teaser (snippets/pkj-assist-v21). */
  paApplyTeam = (function (orig) { return function (json) { orig(json); try { window.__paTeam = PA_TEAM; document.dispatchEvent(new CustomEvent('pa:team', { detail: PA_TEAM })); } catch (e) {} }; })(paApplyTeam);
  function paTeamAuthor() { return PA_TEAM.on ? { name: PA_TEAM.who, photo: PA_TEAM.photo } : null; }
  function paWelcomeText() {
    if (!PA_TEAM.on) return 'Hi! Ask us anything about our saunas.';
    return PA_TEAM.plural ? 'Hi, ' + PA_TEAM.who + ' here. Ask us anything about our saunas.' : 'Hi, I\'m ' + PA_TEAM.who + '. Ask me anything about our saunas.';
  }
  window.__paApplyTeam = paApplyTeam;
  setTimeout(checkHours, 0);

  // Cached storefront HTML can pair pre-P0 markup with this JS for ~30-45
  // min after publish; the toggle/row may not exist on stale pages. Guard so
  // those degrade to the old 3-field form instead of killing the widget.
  function showEmailRow() {
    if (!emailToggle || !emailRow) return;
    emailRow.classList.add('pcm-show');
    emailToggle.setAttribute('aria-expanded', 'true');
    emailToggle.style.display = 'none';
    emailInput.focus();
  }

  function resetEmailRow() {
    if (!emailToggle || !emailRow) return;
    emailRow.classList.remove('pcm-show');
    emailToggle.setAttribute('aria-expanded', 'false');
    emailToggle.style.display = '';
  }

  if (emailToggle) emailToggle.addEventListener('click', showEmailRow);

  scheduleBtn.addEventListener('click', function () {
    paTrack('schedule_call_open', {});
    openModal();
  });
  closeBtn.addEventListener('click', closeModal);
  modal.addEventListener('click', function (e) {
    if (e.target === modal) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.style.display === 'flex') closeModal();
  });

  function resetForm() {
    form.reset();
    [nameInput, phoneInput, emailInput].forEach(function (input) { setError(input, ''); });
    formError.textContent = '';
    formError.hidden = true;
    submitBtn.disabled = false;
    submitBtn.textContent = 'Request a callback';
    resetEmailRow();
  }

  doneBtn.addEventListener('click', function () {
    resetForm();
    formView.hidden = false;
    successView.hidden = true;
    closeModal();
  });

  function validate() {
    var ok = true;
    var nameError = 0;
    var phoneError = 0;
    var emailError = 0;
    var name = nameInput.value.trim();
    if (!name) {
      setError(nameInput, 'Please enter your name.');
      ok = false;
      nameError = 1;
    }
    var phoneCheck = paValidateUsPhone(phoneInput.value);
    if (!phoneCheck.ok) {
      setError(phoneInput, phoneCheck.error);
      ok = false;
      phoneError = 1;
    }
    var email = emailInput.value.trim();
    if (email && !/.+@.+\..+/.test(email)) {
      setError(emailInput, 'Please enter a valid email address.');
      ok = false;
      emailError = 1;
    }
    return { ok: ok, name_error: nameError, phone_error: phoneError, email_error: emailError };
  }

  function handleSubmitSuccess(fullName) {
    window.dispatchEvent(new CustomEvent('pk:lead-success', {detail: {channel: 'call_request', name: fullName, phone: phoneInput.value, email: emailInput.value}}));
    var firstName = fullName.split(/\s+/)[0];
    successMsg.textContent = 'Thanks, ' + firstName + '! ' + (PA_TEAM.on ? PA_TEAM.who + ' will' : 'We\'ll') + ' call you shortly.';
    formView.hidden = true;
    successView.hidden = false;
    submitBtn.disabled = false;
    submitBtn.textContent = 'Request a callback';
  }

  function handleSubmitError() {
    formError.textContent = 'Something went wrong — please try again.';
    formError.hidden = false;
    submitBtn.disabled = false;
    submitBtn.textContent = 'Request a callback';
  }

  function submitViaIframeFallback(payload) {
    var done = false;
    var iframe = document.createElement('iframe');
    iframe.name = 'paf-sink';
    iframe.style.display = 'none';

    var f = document.createElement('form');
    f.method = 'POST';
    f.action = (window.PEAK_ASSIST_API || '') + '/api/schedule-call';
    f.target = 'paf-sink';
    f.style.display = 'none';
    var fields = {
      name: payload.name,
      phone: payload.phone,
      email: payload.email,
      model: payload.model,
      source: payload.source,
      page: payload.page,
      transport: 'iframe'
    };
    Object.keys(fields).forEach(function (key) {
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = key;
      inp.value = fields[key];
      f.appendChild(inp);
    });

    function cleanup() {
      clearTimeout(timer);
      if (f.parentNode) f.parentNode.removeChild(f);
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
    }

    function finish(ok) {
      if (done) return;
      done = true;
      cleanup();
      if (ok) {
        handleSubmitSuccess(payload.name);
      } else {
        paTrack('schedule_call_api_error', { transport: 'iframe' });
        handleSubmitError();
      }
    }

    var timer = setTimeout(function () { finish(false); }, 8000);

    // The very first 'load' a freshly-appended src-less iframe fires is its
    // own empty document, not a response. Ignore that one, then attach a
    // fresh one-shot listener for the real response before submitting.
    iframe.addEventListener('load', function onInitialLoad() {
      iframe.removeEventListener('load', onInitialLoad);
      if (done) return;
      iframe.addEventListener('load', function () {
        try {
          var json = JSON.parse(iframe.contentDocument.body.innerText);
          finish(!!(json && json.ok));
        } catch (err) {
          finish(false);
        }
      }, { once: true });
      document.body.appendChild(f);
      f.submit();
    }, { once: true });

    document.body.appendChild(iframe);
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    formError.textContent = '';
    formError.hidden = true;
    var valid = validate();
    if (!valid.ok) {
      paTrack('schedule_call_error', {
        name_error: valid.name_error, phone_error: valid.phone_error, email_error: valid.email_error
      });
      return;
    }
    var hasEmail = emailInput.value.trim() ? 1 : 0;
    paTrack('schedule_call_submit', { has_email: hasEmail });
    if (window.PK && window.PK.lead) window.PK.lead('schedule_call', { has_email: hasEmail });

    // model stays '' -- the sauna-model select was removed from the modal;
    // the server (peak_assist_api.py schedule_call()) does `(b.get("model")
    // or "").strip()` and only appends a Slack line `if model:`, so '' is a
    // clean no-op server-side, verified 2026-08-05.
    var payload = {
      name: nameInput.value.trim(),
      phone: phoneInput.value.trim(),
      email: emailInput.value.trim(),
      model: '',
      source: 'homepage-footer',
      page: location.pathname
    };
    if (window.PK && window.PK.ids) {
      var sIds = window.PK.ids();
      for (var sk in sIds) { if (sIds[sk]) payload[sk] = sIds[sk]; }
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending…';

    fetch((window.PEAK_ASSIST_API || '') + '/api/schedule-call', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (json) {
        if (res.ok && json && json.ok) {
          handleSubmitSuccess(payload.name);
        } else {
          paTrack('schedule_call_api_error', { transport: 'fetch' });
          handleSubmitError();
        }
      });
    }).catch(function () {
      // fetch() itself rejected (network-level failure, e.g. blocked by a
      // third-party script) — retry via the hidden-iframe form transport.
      submitViaIframeFallback(payload);
    });
  });

  // === Peak Assist chat panel (Tesla-Assist-style) ===
  // Placed after the modal section on purpose: it only ever *reads*
  // scheduleBtn/modal/closeModal (already declared above) or adds brand-new,
  // additive listeners alongside the modal's own — nothing above this line
  // is modified. This is a deliberate parallel copy of the fetch/iframe
  // transport pattern above rather than a shared helper, per instruction.
  var paPanel = document.getElementById('peak-assist-panel');
  var paMessages = document.getElementById('pa-messages');
  var paInput = document.getElementById('pa-input');
  var paSendBtn = document.getElementById('pa-send-btn');
  var paMinBtn = document.getElementById('pa-min-btn');
  var paCloseBtn = document.getElementById('pa-close-btn');
  var paHasThread = false;
  var paLastFocused = null;
  var PA_AVATAR_URL = 'https://cdn.shopify.com/s/files/1/0825/8312/6317/files/peak-assist-icon-basalt.jpg?v=1790907577&width=120&height=120&crop=center'; /* PKJ_ICON_ORANGE v21: 2026 PEAK icon on Solar Flare when nobody is on */

  // API base + reply polling state. Bench mode (this local design bench) is
  // the default (''), meaning every panel endpoint below resolves to a
  // same-origin relative path exactly as before. Setting window.PEAK_ASSIST_API
  // before this script runs switches the panel into "remote" mode: canned
  // replies stop and GET .../api/ask-question/replies polling takes over.
  const API_BASE = (window.PEAK_ASSIST_API || '');
  var paContact = null; // {name, phone} once inline capture succeeds
  var paTid = null;
  var paPendingFirstMessage = null;
  var paPendingFirstMessageRow = null;
  var PA_POLL_MIN = 5000;
  var PA_POLL_MAX = 15000;
  var paPollTimer = null;
  var paPollDelay = PA_POLL_MIN;
  var paPollFailures = 0;
  var paSinceTs = 0;
  var paSeenReplyTs = {};
  var paConnNoteEl = null;

  function paIsOpen() {
    return paPanel.style.display === 'flex';
  }

  function paMakeAvatar(photo) {
    var img = document.createElement('img');
    img.className = 'pa-avatar';
    img.alt = '';
    img.src = (photo && photo.indexOf('peak-assist-avatar') < 0) ? photo : PA_AVATAR_URL; /* PKJ_ICON_MAP: old AI avatar -> new icon */
    img.onerror = function () {
      var fallback = document.createElement('div');
      fallback.className = 'pa-avatar-fallback';
      fallback.textContent = 'P';
      if (img.parentNode) img.parentNode.replaceChild(fallback, img);
    };
    return img;
  }

  function paActionIcon(name) {
    var ns = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(ns, 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    var d;
    if (name === 'up') {
      d = 'M7 10v12M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z';
    } else if (name === 'down') {
      d = 'M17 14V2M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L13 22h0a3.13 3.13 0 0 1-3-3.88Z';
    } else {
      var rect = document.createElementNS(ns, 'rect');
      rect.setAttribute('width', '13');
      rect.setAttribute('height', '13');
      rect.setAttribute('x', '9');
      rect.setAttribute('y', '9');
      rect.setAttribute('rx', '2');
      svg.appendChild(rect);
      d = 'M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1';
    }
    var path = document.createElementNS(ns, 'path');
    path.setAttribute('d', d);
    svg.appendChild(path);
    return svg;
  }

  function paMakeActionBtn(kind, label) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'pa-action pa-action-' + kind;
    btn.setAttribute('aria-label', label);
    if (kind === 'up' || kind === 'down') btn.setAttribute('aria-pressed', 'false');
    btn.appendChild(paActionIcon(kind));
    return btn;
  }

  function paFallbackCopy(text) {
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand('copy'); } catch (err) {}
    document.body.removeChild(ta);
  }

  paMessages.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.pa-action') : null;
    if (!btn) return;
    if (btn.classList.contains('pa-action-copy')) {
      var wrapC = btn.closest('.pa-bubble-wrap');
      var bubbleC = wrapC ? wrapC.querySelector('.pa-bubble') : null;
      var text = bubbleC ? bubbleC.textContent : '';
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).catch(function () { paFallbackCopy(text); });
      } else {
        paFallbackCopy(text);
      }
      return;
    }
    var wrap = btn.closest('.pa-actions');
    if (!wrap) return;
    var up = wrap.querySelector('.pa-action-up');
    var down = wrap.querySelector('.pa-action-down');
    var target = btn.classList.contains('pa-action-up') ? up : down;
    var other = target === up ? down : up;
    var nowPressed = target.getAttribute('aria-pressed') !== 'true';
    target.setAttribute('aria-pressed', nowPressed ? 'true' : 'false');
    other.setAttribute('aria-pressed', 'false');
  });

  function paAddMessage(role, text, author) {
    paHasThread = true;
    var row = document.createElement('div');
    row.className = 'pa-row pa-row-' + role;
    var wrap = document.createElement('div');
    wrap.className = 'pa-bubble-wrap';
    var bubble = document.createElement('div');
    bubble.className = role === 'assistant' ? 'pa-bubble pa-bubble-assistant' : 'pa-bubble pa-bubble-user';
    bubble.textContent = text;
    if (role === 'assistant' && author && author.name) { var who = document.createElement('div'); who.className = 'pa-author'; who.textContent = author.name; wrap.appendChild(who); }
    wrap.appendChild(bubble);
    if (role === 'assistant') {
      row.appendChild(paMakeAvatar(author && author.photo));
      var actions = document.createElement('div');
      actions.className = 'pa-actions';
      actions.appendChild(paMakeActionBtn('up', 'Good response'));
      actions.appendChild(paMakeActionBtn('down', 'Bad response'));
      actions.appendChild(paMakeActionBtn('copy', 'Copy message'));
      wrap.appendChild(actions);
    }
    row.appendChild(wrap);
    paMessages.appendChild(row);
    paMessages.scrollTop = paMessages.scrollHeight;
    return row;
  }

  function paAddErrorNote(userRow) {
    if (!userRow || !userRow.parentNode) return;
    var wrap = userRow.querySelector('.pa-bubble-wrap');
    if (!wrap || wrap.querySelector('.pa-error-note')) return;
    var note = document.createElement('div');
    note.className = 'pa-error-note';
    note.textContent = "Couldn't send — connection issue.";
    wrap.appendChild(note);
  }

  function paShowTyping() {
    var row = document.createElement('div');
    row.className = 'pa-row pa-row-assistant';
    row.id = 'pa-typing-row';
    row.appendChild(paMakeAvatar());
    var bubble = document.createElement('div');
    bubble.className = 'pa-bubble pa-bubble-assistant pa-typing';
    bubble.setAttribute('aria-label', 'Peak Assist is typing');
    for (var i = 0; i < 3; i++) {
      var dot = document.createElement('span');
      dot.className = 'pa-dot';
      bubble.appendChild(dot);
    }
    row.appendChild(bubble);
    paMessages.appendChild(row);
    paMessages.scrollTop = paMessages.scrollHeight;
  }

  function paHideTyping() {
    var row = document.getElementById('pa-typing-row');
    if (row && row.parentNode) row.parentNode.removeChild(row);
  }

  // --- Inline contact capture ---------------------------------------------
  // Shown once, as an assistant bubble containing a form, right after the
  // user's first message renders. Blocks further sends until name+phone are
  // captured, then bridges the held first message through to the backend.
  function paShowCaptureForm() {
    paTrack('peak_assist_capture_shown', {});
    var row = document.createElement('div');
    row.className = 'pa-row pa-row-assistant pa-row-capture';
    row.appendChild(paMakeAvatar());
    var wrap = document.createElement('div');
    wrap.className = 'pa-bubble-wrap';
    var bubble = document.createElement('div');
    bubble.className = 'pa-bubble pa-bubble-assistant';

    var intro = document.createElement('div');
    intro.textContent = "Happy to help! So our team can reach you if we get disconnected — what's your first name and best phone number?";
    bubble.appendChild(intro);

    var form = document.createElement('form');
    form.className = 'pa-capture-form';
    form.noValidate = true;

    var nameField = document.createElement('div');
    nameField.className = 'pa-capture-field';
    var nameInput = document.createElement('input');
    nameInput.type = 'text';
    nameInput.className = 'pa-capture-input';
    nameInput.placeholder = 'First name';
    nameInput.setAttribute('aria-label', 'First name');
    nameInput.autocomplete = 'given-name';
    var nameErr = document.createElement('div');
    nameErr.className = 'pa-capture-error';
    nameField.appendChild(nameInput);
    nameField.appendChild(nameErr);

    var phoneField = document.createElement('div');
    phoneField.className = 'pa-capture-field';
    var phoneInput = document.createElement('input');
    phoneInput.type = 'tel';
    phoneInput.className = 'pa-capture-input';
    phoneInput.placeholder = 'Phone number';
    phoneInput.setAttribute('aria-label', 'Phone number');
    phoneInput.autocomplete = 'tel';
    var phoneErr = document.createElement('div');
    phoneErr.className = 'pa-capture-error';
    phoneField.appendChild(phoneInput);
    phoneField.appendChild(phoneErr);

    // Optional SMS marketing opt-in (2026-10-13, Caleb): unchecked by default. Only when
    // ticked does the backend create a Postscript subscriber (Postscript then texts "Reply Y").
    var smsField = document.createElement('div');
    smsField.className = 'pa-capture-field';
    var smsLabel = document.createElement('label');
    smsLabel.style.cssText = 'display:flex;align-items:center;gap:8px;font-size:14px;cursor:pointer;';
    var smsBox = document.createElement('input');
    smsBox.type = 'checkbox';
    smsBox.checked = false;
    smsBox.style.cssText = 'margin:0;width:16px;height:16px;flex:0 0 auto;';
    smsLabel.appendChild(smsBox);
    smsLabel.appendChild(document.createTextNode('Text me offers & updates from PEAK'));
    var smsTerms = document.createElement('div');
    smsTerms.className = 'pa-capture-consent';
    smsTerms.style.marginTop = '4px';
    [
      'By checking this box, you agree to receive recurring automated marketing text messages (including cart reminders) from PEAK and third parties acting on its behalf at the number provided, and to our ',
      ['Terms of Service', 'https://peaksaunas.com/policies/terms-of-service'],
      ' (including arbitration). Consent is not a condition of purchase. Msg & data rates may apply. Msg frequency varies. Reply HELP for help and STOP to cancel. View our ',
      ['Privacy Policy', 'https://peaksaunas.com/policies/privacy-policy'],
      '.'
    ].forEach(function (part) {
      if (typeof part === 'string') { smsTerms.appendChild(document.createTextNode(part)); return; }
      var a = document.createElement('a');
      a.href = part[1];
      a.target = '_blank';
      a.rel = 'noopener';
      a.textContent = part[0];
      a.style.color = 'inherit';
      a.style.textDecoration = 'underline';
      smsTerms.appendChild(a);
    });
    smsField.appendChild(smsLabel);
    smsField.appendChild(smsTerms);

    var submitBtn = document.createElement('button');
    submitBtn.type = 'submit';
    submitBtn.className = 'pa-capture-submit';
    submitBtn.textContent = 'Start chat';

    var consent = document.createElement('div');
    consent.className = 'pa-capture-consent';
    consent.textContent = 'By starting a chat, you agree we may text you replies about your question at this number. Msg & data rates may apply. Reply STOP to opt out.';

    form.appendChild(nameField);
    form.appendChild(phoneField);
    form.appendChild(smsField);
    form.appendChild(submitBtn);
    form.appendChild(consent);
    bubble.appendChild(form);
    wrap.appendChild(bubble);
    row.appendChild(wrap);
    paMessages.appendChild(row);
    paMessages.scrollTop = paMessages.scrollHeight;

    paInput.disabled = true;
    paSendBtn.disabled = true;

    function setCaptureError(input, errEl, msg) {
      if (msg) {
        errEl.textContent = msg;
        input.classList.add('pa-capture-invalid');
      } else {
        errEl.textContent = '';
        input.classList.remove('pa-capture-invalid');
      }
    }
    nameInput.addEventListener('input', function () { setCaptureError(nameInput, nameErr, ''); });
    phoneInput.addEventListener('input', function () { setCaptureError(phoneInput, phoneErr, ''); });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var ok = true;
      var nameVal = nameInput.value.trim();
      if (!nameVal) {
        setCaptureError(nameInput, nameErr, 'Please enter your first name.');
        ok = false;
      }
      var phoneCheck = paValidateUsPhone(phoneInput.value);
      if (!phoneCheck.ok) {
        setCaptureError(phoneInput, phoneErr, phoneCheck.error);
        ok = false;
      }
      if (!ok) {
        paTrack('peak_assist_capture_error', {
          name_error: nameVal ? 0 : 1,
          phone_error: phoneCheck.ok ? 0 : 1
        });
        return;
      }
      paTrack('peak_assist_capture_submit', {});
      if (window.PK && window.PK.lead) window.PK.lead('chat', {});

      paContact = { name: nameVal, phone: phoneInput.value.trim(), sms: smsBox.checked };
      paInput.disabled = false;
      paSendBtn.disabled = false;

      bubble.innerHTML = '';
      bubble.textContent = 'Thanks, ' + nameVal + '!';

      var pending = paPendingFirstMessage;
      var pendingRow = paPendingFirstMessageRow;
      paPendingFirstMessage = null;
      paPendingFirstMessageRow = null;
      if (pending) paDispatchMessage(pending, pendingRow);
      if (window.innerWidth > 768) {
        setTimeout(function () { paInput.focus(); }, 0);
      }
    });

    if (window.innerWidth > 768) {
      setTimeout(function () { nameInput.focus(); }, 0);
    }
  }

  // --- Reply polling (remote mode only; bench mode never calls this) ------
  function paShowConnNote() {
    if (paConnNoteEl) return;
    paConnNoteEl = document.createElement('div');
    paConnNoteEl.className = 'pa-connection-note';
    paConnNoteEl.textContent = 'Connection hiccup — still trying…';
    paMessages.appendChild(paConnNoteEl);
    paMessages.scrollTop = paMessages.scrollHeight;
  }

  function paClearConnNote() {
    if (paConnNoteEl && paConnNoteEl.parentNode) paConnNoteEl.parentNode.removeChild(paConnNoteEl);
    paConnNoteEl = null;
  }

  function paResetConnectionState() {
    paPollDelay = PA_POLL_MIN;
    paPollFailures = 0;
    paSinceTs = 0;
    paSeenReplyTs = {};
    paClearConnNote();
  }

  function paStopPolling() {
    if (paPollTimer) {
      clearTimeout(paPollTimer);
      paPollTimer = null;
    }
  }

  function paPausePolling() {
    paStopPolling();
  }

  function paScheduleNextPoll(delay) {
    paStopPolling();
    paPollTimer = setTimeout(paPollReplies, delay);
  }

  function paPollReplies() {
    paPollTimer = null;
    if (!API_BASE || !paTid || !paIsOpen() || document.hidden) return;
    var url = API_BASE + '/api/ask-question/replies?tid=' + encodeURIComponent(paTid) + '&since=' + encodeURIComponent(paSinceTs);
    fetch(url).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok || !json || !json.ok) throw new Error('bad replies response');
        paPollFailures = 0;
        paPollDelay = PA_POLL_MIN;
        paClearConnNote();
        var replies = json.replies || [];
        var typingCleared = false;
        replies.forEach(function (r) {
          var key = String(r.ts);
          if (paSeenReplyTs[key]) return;
          paSeenReplyTs[key] = true;
          if (r.ts && r.ts > paSinceTs) paSinceTs = r.ts;
          if (!typingCleared) { paHideTyping(); typingCleared = true; }
          paAddMessage('assistant', r.message || r.text || '', { name: r.author, photo: r.avatar });
          paTrack('peak_assist_reply_received', {});
        });
      });
    }).catch(function () {
      paPollFailures++;
      paPollDelay = PA_POLL_MAX;
      if (paPollFailures >= 4) paShowConnNote();
    }).then(function () {
      paScheduleNextPoll(paPollDelay);
    });
  }

  function paResumePollingIfNeeded() {
    if (!API_BASE || !paTid || !paIsOpen() || document.hidden || paPollTimer) return;
    paScheduleNextPoll(0);
  }

  function paStartPolling() {
    paResumePollingIfNeeded();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      paPausePolling();
    } else {
      paResumePollingIfNeeded();
    }
  });

  function paDispatchMessage(text, userRow) {
    var payload = {
      message: text,
      name: paContact ? paContact.name : '',
      phone: paContact ? paContact.phone : '',
      page: location.pathname,
      tid: paTid
    };
    if (!paTid) payload.sms_consent = !!(paContact && paContact.sms);
    if (window.PK && window.PK.ids) {
      var cIds = window.PK.ids();
      for (var ck in cIds) { if (cIds[ck]) payload[ck] = cIds[ck]; }
    }
    paPostMessage(payload, function (ok, tid) {
      if (!ok) { paAddErrorNote(userRow); return; }
      if (!payload.tid) window.dispatchEvent(new CustomEvent('pk:lead-success', {detail: {channel: 'chat', name: payload.name, phone: payload.phone}}));
      if (tid && !paTid) {
        paTid = tid;
        paSinceTs = Date.now();
        paStartPolling();
      }
    });
    paShowTyping();
    if (!API_BASE) {
      setTimeout(function () {
        paHideTyping();
        paAddMessage('assistant', 'Thanks! ' + (PA_TEAM.on ? PA_TEAM.who : 'our team') + ' will be with you in just a minute.');
      }, 1200);
    }
  }

  function paPostMessageViaIframe(payload, callback) {
    var done = false;
    var iframe = document.createElement('iframe');
    iframe.name = 'pa-sink';
    iframe.style.display = 'none';

    var f = document.createElement('form');
    f.method = 'POST';
    f.action = API_BASE + '/api/ask-question';
    f.target = 'pa-sink';
    f.style.display = 'none';
    var fields = {
      message: payload.message,
      name: payload.name || '',
      phone: payload.phone || '',
      page: payload.page,
      tid: payload.tid || '',
      transport: 'iframe'
    };
    if (payload.sms_consent) fields.sms_consent = 'true';
    Object.keys(fields).forEach(function (key) {
      var inp = document.createElement('input');
      inp.type = 'hidden';
      inp.name = key;
      inp.value = fields[key];
      f.appendChild(inp);
    });

    function cleanup() {
      clearTimeout(timer);
      if (f.parentNode) f.parentNode.removeChild(f);
      if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
    }
    function finish(ok, tid) {
      if (done) return;
      done = true;
      cleanup();
      callback(ok, tid);
    }
    var timer = setTimeout(function () { finish(false); }, 8000);

    iframe.addEventListener('load', function onInitialLoad() {
      iframe.removeEventListener('load', onInitialLoad);
      if (done) return;
      iframe.addEventListener('load', function () {
        try {
          var json = JSON.parse(iframe.contentDocument.body.innerText);
          finish(!!(json && json.ok), json && json.tid);
        } catch (err) {
          finish(false);
        }
      }, { once: true });
      document.body.appendChild(f);
      f.submit();
    }, { once: true });

    document.body.appendChild(iframe);
  }

  function paPostMessage(payload, callback) {
    fetch(API_BASE + '/api/ask-question', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (json) {
        callback(!!(res.ok && json && json.ok), json && json.tid);
      });
    }).catch(function () {
      paPostMessageViaIframe(payload, callback);
    });
  }

  function paSendMessage(text) {
    text = (text || '').trim();
    if (!text) return;
    paRemoveChips();
    paMsgSeq++;
    paTrack('peak_assist_message_send', {
      seq: paMsgSeq, chars: text.length, gated: paContact ? 0 : 1
    });
    var userRow = paAddMessage('user', text);
    if (!paContact) {
      // First message ever in this thread: hold it and collect contact info
      // before it's bridged to the backend. Later messages skip this.
      paPendingFirstMessage = text;
      paPendingFirstMessageRow = userRow;
      paShowCaptureForm();
      return;
    }
    paDispatchMessage(text, userRow);
  }

  function paUpdateSendState() {
    if (paInput.value.trim().length > 0) {
      paSendBtn.classList.add('pa-active');
    } else {
      paSendBtn.classList.remove('pa-active');
    }
  }

  function paHandlePanelSend() {
    var val = paInput.value.trim();
    paInput.value = '';
    paUpdateSendState();
    paSendMessage(val);
  }

  var PA_CHIPS = ['How much is delivery?', 'Which size fits my space?', 'What financing is available?'];

  function paRemoveChips() {
    var c = document.getElementById('pa-chips');
    if (c) c.remove();
  }

  function paRenderChips() {
    if (document.getElementById('pa-chips')) return;
    var wrap = document.createElement('div');
    wrap.id = 'pa-chips';
    wrap.className = 'pa-chips';
    PA_CHIPS.forEach(function (q) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pa-chip';
      b.textContent = q;
      b.addEventListener('click', function () {
        paRemoveChips();
        paSendMessage(q);
      });
      wrap.appendChild(b);
    });
    paMessages.appendChild(wrap);
  }

  // iOS: position:fixed ignores the software keyboard, so the sheet must be
  // lifted and shrunk to the VISUAL viewport while it is open. bottom and
  // max-height are not in the transition list, so these updates are instant.
  var paVV = window.visualViewport;

  function paSyncSheet() {
    if (!paVV || !paIsOpen() || window.innerWidth > 768) return;
    var hidden = Math.max(0, window.innerHeight - paVV.height - paVV.offsetTop);
    paPanel.style.bottom = hidden + 'px';
    paPanel.style.maxHeight = Math.round(paVV.height * 0.98) + 'px';
  }

  function paResetSheet() {
    paPanel.style.bottom = '';
    paPanel.style.maxHeight = '';
  }

  if (paVV) {
    paVV.addEventListener('resize', paSyncSheet);
    paVV.addEventListener('scroll', paSyncSheet);
  }

  function paOpenPanel(prefill) {
    paTrack('peak_assist_panel_open', {
      entry: prefill ? 'pill_prefill' : (paHasThread ? 'resume' : 'bar_click'),
      has_contact: paContact ? 1 : 0
    });
    if (modal.style.display === 'flex') closeModal();
    paLastFocused = document.activeElement;
    paPanel.classList.add('pa-enter');
    paPanel.style.display = 'flex';
    void paPanel.offsetHeight;
    requestAnimationFrame(function () { paPanel.classList.remove('pa-enter'); });
    setTimeout(function () { paPanel.classList.remove('pa-enter'); }, 150);
    paPanel.setAttribute('aria-hidden', 'false');
    if (!paHasThread) {
      paAddMessage('assistant', paWelcomeText(), paTeamAuthor());
      paRenderChips();
    }
    if (window.innerWidth > 768) {
      setTimeout(function () { paInput.focus(); }, 0);
    }
    if (prefill) paSendMessage(prefill);
    paSyncSheet();
    paResumePollingIfNeeded();
  }

  function paMinimizePanel() {
    if (!paClosing) paTrack('peak_assist_panel_minimize', {
      has_thread: paHasThread ? 1 : 0, messages: paMsgSeq
    });
    paPanel.style.display = 'none';
    paPanel.setAttribute('aria-hidden', 'true');
    paResetSheet();
    if (paLastFocused && typeof paLastFocused.focus === 'function') paLastFocused.focus();
    paPausePolling();
  }

  function paClosePanel() {
    // X = fresh start; minimize (—) = resume via a click anywhere on the
    // Ask a Question bar (Caleb 2026-07-27).
    paTrack('peak_assist_panel_close', {
      has_thread: paHasThread ? 1 : 0, messages: paMsgSeq, captured: paContact ? 1 : 0
    });
    paClosing = true;
    paMinimizePanel();
    paClosing = false;
    paMsgSeq = 0;
    paMessages.innerHTML = '';
    paHasThread = false;
    paContact = null;
    paTid = null;
    paPendingFirstMessage = null;
    paPendingFirstMessageRow = null;
    paInput.disabled = false;
    paSendBtn.disabled = false;
    paResetConnectionState();
  }

  paMinBtn.addEventListener('click', paMinimizePanel);
  paCloseBtn.addEventListener('click', paClosePanel);
  paInput.addEventListener('input', paUpdateSendState);
  paSendBtn.addEventListener('click', paHandlePanelSend);
  paInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      paHandlePanelSend();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && paIsOpen()) paMinimizePanel();
  });

  // Additive cross-closing with the Schedule-a-Call modal: a second,
  // independent listener alongside the modal's own — does not touch
  // openModal/scheduleBtn's existing listener at all.
  scheduleBtn.addEventListener('click', function () {
    if (paIsOpen()) paMinimizePanel();
  });
})();
